import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';


import Vue from 'vue'

const getDefaultStateForRFIDS = () => {
    return {
       rfids:[],
       data:{},
       filter:{
            keyword:"",
            active_only:"1"
        },
       is_created:null,
       is_updated:null,
       is_deleted:null
    }
}

// state
const state = getDefaultStateForRFIDS()

// getters
const getters = {

}

// mutations
const mutations = {
    RESET_STATE_FOR_RFIDS (state) {
        Object.assign(state, getDefaultStateForRFIDS())
    },

    FETCH_ALL(state, data){
        state.rfids = data
    },
    FETCH(state, data){
      state.data = data
    },
    SET_IS_DELETED(state, data){
        state.is_deleted = data
    },
    SET_IS_CREATED(state, data){
        state.is_created = data
    },
    SET_IS_UPDATED(state, data){
        state.is_updated = data
    },
    QUICK_SEARCH(state, data){

      state.rfids = data

    },
    SET_FILTER(state, data)
    {
      state.filter = data
    },
    FETCH(state, data)
    {
        state.asset_data = data
    }
}

// actions
const actions = {
    resetState({ commit }, payload) {
        commit("RESET_STATE_FOR_RFIDS")
    },
    fetch({ commit }, data) {
        return axios.post(apiRoutes['RETRIEVE_RFID'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('FETCH', response.data.data)
              } else {
                commit('FETCH', {})
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
     },
    async create({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['CREATE_RFID'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                let id  = response.data.data.id
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: "RFID has been created",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                commit("SET_IS_CREATED", 1)

            }
            else
            {
                let errors = response.data.data.errors
                commit("SET_IS_CREATED", 0)

                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")

                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }


            }

          })
          .catch((error) => {

              if (error.response) {
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Problem Creating Asset")
              }
          });
    },
    async update({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['UPDATE_RFID'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                let id  = response.data.data.id
                Vue.notify({
                    group: 'notify',
                    type: 'success',
                    text: "RFID has been updated",
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                commit("SET_IS_UPDATED", 1)

            }
            else
            {
                let errors = response.data.data.errors
                commit("SET_IS_UPDATED", 0)
                if(Array.isArray(errors))
                {
                  console.log(errors)
                  let msg = errors.join("\n")

                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }


            }

          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Application exception")
              }
          });
    },
    async delete({ commit, dispatch }, data) {
        await axios
            .post(apiRoutes['DELETE_PRODUCT_CODE'], data, authHeader())
            .then(function (response) {
              if(response.data.code == 1)
              {
                  let id  = response.data.data
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: "Product Code has been deleted",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  //dispatch("customers/fetch", {"code":data.contact_code}, {root:true})
                 // commit("SET_BANK_ACCOUNT_ID", id)
                 commit("SET_IS_DELETED", 1)
  
              }
              else
              {
                  let errors = response.data.data.errors
  
                  if(Array.isArray(errors))
                  {
                    console.log(errors)
                    let msg = errors.join("\n")
  
                    Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  }
  
  
              }
  
            })
            .catch((error) => {
                // alert(error)
                // console.log(error.response)
  
                if (error.response) {
                    //alert(error.response.data.message)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                }
                else
                {
                    //console.log("Problem submitting New Post", error);
                    alert("Application exception")
                }
            });
    },
    async listAssetClassifications({ commit }, data) {
        return axios.post(apiRoutes['LIST_ASSET_CLASSIFICATIONS'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('SET_ASSET_CLASSIFICATIONS', response.data.data)
              } 
              else 
              {
                commit('SET_ASSET_CLASSIFICATIONS', [])
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem querying data", error);
              }
          });
    },
    async listRfids({ commit }, data) {
        console.log(data)
        return axios.post(apiRoutes['LIST_RFID_FOR_ASSETS'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('SET_RFIDS', response.data.data)
              } 
              else 
              {
                commit('SET_RFIDS', [])
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem querying data", error);
              }
          });
    },
    quickSearch({ commit }, data) {
        return axios.post(apiRoutes['RFID_QUICK_SEARCH'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('QUICK_SEARCH', response.data.data)
                commit('SET_FILTER', data)
              } 
              else 
              {
                commit('QUICK_SEARCH', [])
                commit('SET_FILTER', data)
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem submitting New Customer", error);
              }
          });
    },
}

export {
    state,
    getters,
    actions,
    mutations
}
